//时间格式转字符串
Date.prototype.format = Date.prototype.ToString = function (format) {
    /* 
    * eg:format="yyyy-MM-dd hh:mm:ss"; 
    */
    var o = {
        "M+": this.getMonth() + 1, // month  
        "d+": this.getDate(), // day  
        "H+": this.getHours(), // hour  
        "m+": this.getMinutes(), // minute  
        "s+": this.getSeconds(), // second  
        "q+": Math.floor((this.getMonth() + 3) / 3), // quarter
        "S+": this.getMilliseconds()
        // millisecond  
    }
    if (!format) {
        return this.toString();
    }
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4
            - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
            var formatStr = "";
            for (var i = 1; i <= RegExp.$1.length; i++) {
                formatStr += "0";
            }

            var replaceStr = "";
            if (RegExp.$1.length == 1) {
                replaceStr = o[k];
            } else {
                formatStr = formatStr + o[k];
                var index = ("" + o[k]).length;
                formatStr = formatStr.substr(index);
                replaceStr = formatStr;
            }
            format = format.replace(RegExp.$1, replaceStr);
        }
    }
    return format;
}
const DateTime = {
    get Now() {
        return new Date();
    }
}
export { DateTime }

export function Trim(str) {
    let re = /^(\s*)|(\s*)$/g;
    return String(str).replace(re, '');
}

export function randomStr(len) {
    var ans = '';
    var arr = "abcdefghijklmnABCDEFGHIJKLMN";
    for (var i = len; i > 0; i--) {
        ans += arr[Math.floor(Math.random() * arr.length)];
    }
    return ans;
}

//清除空格
String.prototype.Trim = String.prototype.trim = function () {
    return this.replace(/(^\s*)|(\s*$)/g, "");
}
//去除字符串前面空格或指定字符  
String.prototype.TrimStart = function (c) {
    if (c == null || c == "") {
        let str = this.replace(/^s*/, '');
        return str;
    }
    else {
        var rg = new RegExp("^" + c + "*");
        let str = this.replace(rg, '');
        return str;
    }
}
//去除字符串后面空格或指定字符  
String.prototype.TrimEnd = function (c) {
    if (c == null || c == "") {
        let str = this;
        let rg = /s/;
        let i = str.length;
        while (rg.test(str.charAt(--i)));
        return str.slice(0, i + 1);
    }
    else {
        let str = this;
        let rg = new RegExp(c);
        let i = str.length;
        while (rg.test(str.charAt(--i)));
        return str.slice(0, i + 1);
    }
}

//是否为空·
export function isNull(val) {
    if ("" === val || null === val || typeof (val) == "undefined") {
        return true;
    }
    else {
        return false;
    }
}

String.prototype.isNull = function () {
    return isNull(Trim(this));
}


export function GetRandomString(len, start, end) {
    // 验证输入参数
    if (typeof len !== 'number' || len <= 0) {
        throw new Error('长度参数必须为正整数');
    }
    let str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    if (typeof start == 'number' && typeof end == 'number') {
        str = str.substring(start, end);
    }
    else if (typeof end  == 'number') {
        str = str.substring(start);
    }
    let result = '';
    for (let i = len; i > 0; --i) {
        result += str[Math.floor(Math.random() * str.length)];
    }
    return result;
}